import React from 'react';
import { Button, Spinner } from '@spark';
import { useAuth } from '@/features/auth/AuthContext';
import { TRAIN_ACTION_LABEL } from '@/features/trainings/constants';

const Submit = ({ onClick, loading, disabled, loadingText = "Training" }) => {
    const { role } = useAuth();
    return (
        <div>
            <Button
                variant="primary"
                size="small"
                type="button"
                onClick={onClick}
                disabled={loading || disabled || role === 'Viewer'}
                disableWhenReadOnly
                startIcon={loading ? <Spinner size="small" /> : undefined}
            >
                {loading ? loadingText : TRAIN_ACTION_LABEL}
            </Button>
        </div>
    );
};

export default Submit;
